"use client";
import "./headerfixture.scss";
import React, { useState, useRef, useEffect, lazy } from "react";
import EyeLight from "@/public/EyeLight.svg";
import Subtract from "@/public/Subtract.svg";
import Subtract_Dark from "@/public/Subtract_Dark.svg";
import SelectButtonDate from "../SelectButtonDate";
import PopupButton from "../PopupButton"
import PopupButtonDesktop from "../PopupButtonDesktop"
import TabTatCa from "@/assets/images/icon_tat_ca_black.png";
import TabTatCaWhite from "@/assets/images/icon_tat_ca_white.png";
import TabTatCaActive from "@/assets/images/icon_tat_ca1.png";
import TabTrucTiep from "@/assets/images/icon_truc_tiep.gif";
import TabHot from "@/assets/images/icon_hot_black.png";
import TabHotWhite from "@/assets/images/icon_hot_white.png";
import TabHotActive from "@/assets/images/icon_hot_active.png";
import TabYeuThichActive from "@/assets/images/icon_star_active.png";
import TabYeuThich from "@/assets/images/icon_star_black.png";
import TabYeuThichWhite from "@/assets/images/icon_star_white.png";
import { ALL, FAVORITE, LIVE, RESULT, BANKER, BANKER_EXTENDS, LEAGUES_HOT, SEARCH_TYPE, SEARCH_HOT_LEAGUE_DEFAULT, FILTER_TYPE } from "@/contants";
import {
  SET_FIXTURES_ROUTE, SET_SEARCH_TEXT, SET_SEARCH_TEXT_VALUE, CHANGE_BOOKMAKER, CHANGE_BOOKMAKER_EXTEND, SET_TOGGLE_CARD,
  SET_TOGGLE_RANK,
  SET_TOGGLE_CORNER,
  SET_TOGGLE_HDC,
  SET_TOGGLE_OU,
  SET_TOGGLE_X2,
  SET_DATE_SELECTED,
  SET_AMOUNT_MATCHES_CURRENT_ALL,
  SET_TOTAL_MATCHES_ALL,
  SET_AMOUNT_MATCHES_CURRENT_LIVE,
  SET_TOTAL_MATCHES_LIVE,
  SET_AMOUNT_MATCHES_CURRENT_RESULT,
  SET_TOTAL_MATCHES_RESULT,
  SET_SEARCH_TYPE
} from "@/lib/redux/reducers/actionTypes";
import { useSelector, useDispatch } from 'react-redux';
import HideShowButton from "@/components/client/HideShowButton"
const FilterMatches = lazy(() => import("@/components/client/FilterMatches"));
import { Image } from '@/lib/target';
import { useIsMobile } from "@/lib/isMobile";

import { useTheme } from "@/context/ThemeContext";
import dayjs from 'dayjs'; // Core Day.js
import utc from 'dayjs/plugin/utc.js'; // UTC plugin
import timezone from 'dayjs/plugin/timezone.js'; // Timezone plugin
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

const HeaderFixture = () => {
  const childRef = useRef(null);
  const focused = useSelector((state) => state.fixtureRouteReducer.currentRoute)
  const searchText = useSelector((state) => state.searchReducer.searchText);
  const toggleReducer = useSelector((state) => state.toggleReducer);
  const searchReducer = useSelector((state) => state.searchReducer);
  const [toggleHDC, setToggleHDC] = useState(toggleReducer.hdc);
  const [toggleOU, setToggleOU] = useState(toggleReducer.ou);
  const [toggleX2, setToggleX2] = useState(toggleReducer.x2 ?? true);
  const [toggleRank, setToggleRank] = useState(toggleReducer.rank);
  const [toggleCard, setToggleCard] = useState(toggleReducer.card);
  const [toggleCorner, setToggleCorner] = useState(toggleReducer.corner);
  const [showTogglePopup, setShowTogglePopup] = useState(false);
  const [showToggleConfirm, setShowToggleConfirm] = useState(false);
  const toggleRef = useRef(null);
  const eyeRef = useRef(null);
  const isMobile = useIsMobile();
  const { theme } = useTheme();

  const dispatch = useDispatch();

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const todayFormatted = dayjs().format("DD-MM-YYYY");

  const handleFocus = (item) => {
    dispatch({ type: SET_FIXTURES_ROUTE, payload: item });
  };
  const handleCloseSearch = () => {
    dispatch({ type: SET_SEARCH_TEXT, payload: '' });
    dispatch({ type: SET_SEARCH_TEXT_VALUE, payload: ''});
  }
  const setBookerMarker = (bookmarker) => {
    dispatch({ type: CHANGE_BOOKMAKER, payload: bookmarker });
  }
  const setBookMarkerExtend = (bookmarkerExtend) => {
    dispatch({ type: CHANGE_BOOKMAKER_EXTEND, payload: bookmarkerExtend })
  }
  const applyShowHide = () => {
    setShowToggleConfirm(false);
    handleShowHideToggle(false);
    saveToggleSettings();
  }
  const handleShowHideToggle = (show) => {
    if (isMobile) {
      if (show) {
        document.body.classList.remove('keobongvip-root');
      } else {
        document.body.classList.add('keobongvip-root');
      }
    }
   
    setShowTogglePopup(show);
  }
  
  const saveToggleSettings = () => {
    dispatch({ type: SET_TOGGLE_HDC, payload: toggleHDC })
    dispatch({ type: SET_TOGGLE_OU, payload: toggleOU })
    dispatch({ type: SET_TOGGLE_X2, payload: toggleX2 })
    dispatch({ type: SET_TOGGLE_RANK, payload: toggleRank })
    dispatch({ type: SET_TOGGLE_CARD, payload: toggleCard })
    dispatch({ type: SET_TOGGLE_CORNER, payload: toggleCorner })
  }
  const handleClickEye = () => {
    handleShowHideToggle(!showTogglePopup);
  }
  const handleClickOutside = (event) => {
    if (eyeRef.current && eyeRef.current.contains(event.target)) {
      return;
    }

    if (toggleRef.current && !toggleRef.current.contains(event.target)) {
      handleShowHideToggle(false);
    }
  };
  const handleClickHDSudung = () => {
    alert("HDSudung clicked");
  }
  const changeSortTypeToDefault = () => {
    if (childRef.current) {
      childRef.current.triggerClearFilter();
    }
  }
  const handleClickClear = () => {
    dispatch({ type: SET_TOGGLE_CORNER, payload: true, });
    dispatch({ type: SET_TOGGLE_CARD,  payload: true, });
    dispatch({ type: SET_TOGGLE_RANK, payload: true, });
    dispatch({ type: SET_SEARCH_TEXT_VALUE, payload: "", });
    dispatch({ type: SET_SEARCH_TYPE, payload: FILTER_TYPE[0].value, });
    dispatch({ type: SET_DATE_SELECTED, payload: todayFormatted });
    dispatch({ type: SET_AMOUNT_MATCHES_CURRENT_ALL, payload: 0 });
    dispatch({ type: SET_TOTAL_MATCHES_ALL, payload: 0 });
    dispatch({ type: SET_AMOUNT_MATCHES_CURRENT_LIVE, payload: 0 });
    dispatch({ type: SET_TOTAL_MATCHES_LIVE, payload: 0 });
    dispatch({ type: SET_AMOUNT_MATCHES_CURRENT_RESULT, payload: 0 });
    dispatch({ type: SET_TOTAL_MATCHES_RESULT, payload: 0 });
    changeSortTypeToDefault()
  };

  const shouldHideOrShowClearBtn = () => {
    if(!toggleReducer?.corner || !toggleReducer?.card || !toggleReducer?.rank || (searchReducer.searchTextValue !== "") || (searchReducer.dateSelected !== todayFormatted)){
      return true
    }
  }

  return (
    <React.Fragment>
      <div className="header-fixture">
        <div className="hidden @lg:block h-[2.375rem] bg-transparent @xl:bg-header-blue dark:bg-transparent @xl:dark:bg-dark-slate rounded-md w-full justify-between my-0 @lg:my-0 @xl:my-3 gap-4">
          <div className="flex gap-5">
            <SelectButtonDate pastDateDisabled={true} />
            <Image src={Subtract} className="hidden @md:hidden @lg:hidden @xl:block dark:hidden w-10 h-10" />
            <Image src={Subtract_Dark} className="hidden @md:hidden @lg:hidden @xl:dark:block w-10 h-10" />
            <FilterMatches ref={childRef}/>
            <HideShowButton />
            <div className="flex-1 flex items-center justify-end">
                  <button
                    className={`bg-stroke-o3 dark:bg-league-white dark:text-league-dark-detail font-montserrat text-[0.75rem] font-semibold rounded-[4px] px-2 h-7 mx-2 ${!shouldHideOrShowClearBtn() ? 'text-blur-gray hidden' : 'hover:bg-white hover:dark:bg-[#4e4d4d] hover:text-[#4C97F3] text-blue-match dark:text-stroke-o3'}`}
                    onClick={handleClickClear}
                    disabled={!shouldHideOrShowClearBtn()}
                  >
                    Xóa bộ lọc
                  </button>
            </div>
          </div>
          <div className="flex">
            <div className="@xl:block flex justify-end items-center py-[5px]">
            </div>
            <div className="block @lg:hidden @xl:flex-none gap-2">
              <PopupButton data={BANKER} type={'bookmarker'} />
              <PopupButton data={BANKER_EXTENDS} />
            </div>
          </div>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex rounded-md bg-header-blue @md:bg-white dark:bg-league-dark text-dark-gray font-semi-bold whitespace-nowrap overflow-x-auto">
            <div className={`hover:cursor-pointer rounded-md px-2 @xl:px-4 py-[0.313rem] flex gap-2 items-center ${focused === ALL ? 'bg-button-blue-bet text-white-half dark:text-white' : 'dark:text-stroke-o3'}`} onClick={() => handleFocus(ALL)}>
              <Image className="hidden @lg:block" src={focused === ALL ? TabTatCaActive : (theme==='light' ? TabTatCa : TabTatCaWhite)} height={18} width={17} alt="Net88" />
              <span>Tất Cả</span>
            </div>
            <p className={`py-[0.313rem] ${[ALL, LIVE].includes(focused) ? 'text-light-gray dark:text-league-dark' : 'dark:text-league-dark-detail'}`}>|</p>
            <div className={`hover:cursor-pointer rounded-md px-2 @xl:px-4 py-[0.313rem] flex gap-2 items-center ${focused === LIVE ? 'bg-button-blue-bet text-white-half dark:text-white' : 'dark:text-stroke-o3'}`} onClick={() => handleFocus(LIVE)}>
              <Image className="hidden @lg:block" src={TabTrucTiep} height={16} width={16} alt="Net88" />
              <span>Kèo trực tuyến</span>
            </div>
            <p className={`py-[0.313rem] ${[LIVE, RESULT, SEARCH_HOT_LEAGUE_DEFAULT].includes(focused) ? 'text-light-gray dark:text-league-dark' : 'dark:text-league-dark-detail'}`}>|</p>
            <div className={`hover:cursor-pointer rounded-md px-2 @xl:px-4 py-[0.313rem] flex gap-2 items-center ${focused === SEARCH_HOT_LEAGUE_DEFAULT ? 'bg-button-blue-bet text-white-half dark:text-white' : 'dark:text-stroke-o3'}`} onClick={() => handleFocus(SEARCH_HOT_LEAGUE_DEFAULT)}>
              <Image className="hidden @lg:block" src={focused === SEARCH_HOT_LEAGUE_DEFAULT ? TabHotActive : (theme ==='light' ? TabHot : TabHotWhite)} height={17} width={13} alt="Net88" />
              <span>Hot</span>
            </div>
            <p className={`py-[0.313rem] ${[FAVORITE, RESULT].includes(focused) ? 'text-light-gray dark:text-league-dark' : 'dark:text-league-dark-detail'}`}>|</p>
            <div className={`hover:cursor-pointer rounded-md px-2 @xl:px-4 py-[0.313rem] flex gap-2 items-center ${focused === FAVORITE ? 'bg-button-blue-bet text-white-half dark:text-white' : 'dark:text-stroke-o3'}`} onClick={() => handleFocus(FAVORITE)}>
              <Image className="hidden @lg:block" src={focused === FAVORITE ? TabYeuThichActive : (theme==='light' ? TabYeuThich : TabYeuThichWhite)} height={18} width={18} alt="Net88" />
              <span>Yêu thích</span>
            </div>
          </div>
          <div className="block @md:block @lg:hidden">
            <div className="flex gap-1.5">
              <FilterMatches ref={childRef}/>


              <button onClick={() => handleClickEye()} ref={eyeRef}>
                <Image src={EyeLight} width={20} height={20} alt="mở rộng" className="hover:cursor-pointer h-[24px] w-[24px]"/>
              </button>
              
              
              <div className={`show-hide-popup  bg-stroke-o3 ${showTogglePopup ? 'visible' : ''}`} ref={toggleRef}>
                <div className="px-2 py-3 mt-2">
                  <div className="bg-white rounded-lg px-2 py-3 font-bold text-center">TỈ LỆ KÈO</div>
                  <div className="rounded-lg border-1 border-blue-500 px-3 py-2 text-left mt-2 bg-white-half flex items-center">
                    <label className="inline-flex items-center w-full">
                      <input className="form-checkbox h-5 w-5 text-blue-match" type="checkbox"
                        checked={toggleHDC}
                        onChange={() => {
                          setToggleHDC(!toggleHDC);
                          setShowToggleConfirm(true);
                        }}
                      />
                      <span className="ml-2 text-dark-gray font-bold w-full">HDC</span>
                    </label>
                  </div>
                  <div className="rounded-lg border-1 border-blue-500 px-3 py-2 text-left mt-2 bg-white-half flex items-center">
                    <label className="inline-flex items-center w-full">
                      <input className="form-checkbox h-5 w-5 text-blue-match" type="checkbox"
                        checked={toggleOU}
                        onChange={() => {
                          setToggleOU(!toggleOU);
                          setShowToggleConfirm(true);
                        }}
                      />
                      <span className="ml-2 text-dark-gray font-bold w-full">O/U</span>
                    </label>
                  </div>
                  <div className="rounded-lg border-1 border-blue-500 px-3 py-2 text-left mt-2 bg-white-half flex items-center">
                    <label className="inline-flex items-center w-full">
                      <input className="form-checkbox h-5 w-5 text-blue-match" type="checkbox"
                        checked={toggleX2}
                        onChange={() => {
                          setToggleX2(!toggleX2);
                          setShowToggleConfirm(true);
                        }}
                      />
                      <span className="ml-2 text-dark-gray font-bold w-full">1X2</span>
                    </label>
                  </div>
                  <div className="border-header-blue w-full border-1 mt-2"></div>
                  <div className="bg-white rounded-lg px-2 py-3 mt-2 font-bold text-center">THÔNG TIN THẺ</div>
                  <div className="rounded-lg border-1 border-blue-500 px-3 py-2 text-left mt-2 bg-white-half flex items-center">
                    <label className="inline-flex items-center w-full">
                      <input className="form-checkbox h-5 w-5 text-blue-match" type="checkbox"
                        checked={toggleRank}
                        onChange={() => {
                          setToggleRank(!toggleRank);
                          setShowToggleConfirm(true);
                        }}
                      />
                      <span className="ml-2 text-dark-gray font-bold w-full">Xếp Hạng - Đội Bóng</span>
                    </label>
                  </div>
                  <div className="rounded-lg border-1 border-blue-500 px-3 py-2 text-left mt-2 bg-white-half flex items-center">
                    <label className="inline-flex items-center w-full">
                      <input className="form-checkbox h-5 w-5 text-blue-match" type="checkbox"
                        checked={toggleCard}
                        onChange={() => {
                          setToggleCard(!toggleCard);
                          setShowToggleConfirm(true);
                        }}
                      />
                      <span className="ml-2 text-dark-gray font-bold w-full">Thẻ Vàng/Đỏ</span>
                    </label>
                  </div>
                  <div className="rounded-lg border-1 border-blue-500 px-3 py-2 text-left mt-2 bg-white-half flex items-center">
                    <label className="inline-flex items-center w-full">
                      <input className="form-checkbox h-5 w-5 text-blue-match" type="checkbox"
                        checked={toggleCorner}
                        onChange={() => {
                          setToggleCorner(!toggleCorner);
                          setShowToggleConfirm(true);
                        }}
                      />
                      <span className="ml-2 text-dark-gray font-bold w-full">Phạt Góc</span>
                    </label>
                  </div>
                </div>

                <div className="px-2 py-3 rounded-md bg-white dark:bg-league-white flex gap-2 text-xs">
                  <button className="rounded-md bg-white-half dark:bg-gray-400 dark:text-gray-900 p-3 w-2/5"
                    onClick={() => setShowTogglePopup(false)}
                  >Đóng</button>
                  <button className={`rounded-md dark:bg-gray-400 dark:text-gray-900 p-3 w-3/5 ${showToggleConfirm ? 'bg-large-blue text-white' : 'bg-white-half'}`}
                    onClick={() => {
                      applyShowHide();
                    }}
                  >Xác Nhận</button>
                </div>
              </div>
            </div>
          </div>
          <div className="hidden @md:hidden @lg:block">
            <div className="flex gap-3">
              <PopupButtonDesktop data={BANKER_EXTENDS} handleChange={setBookMarkerExtend} />
              <button className="hidden bg-button-blue-bet text-white-half font-montserrat text-[0.75rem] font-semibold rounded-md px-2 py-1 h-7" onClick={handleClickHDSudung}>HD sử dụng</button>
            </div>
          </div>
        </div>
        <div className="flex justify-between mt-4 @lg:hidden">
          <div className="flex">
            <SelectButtonDate pastDateDisabled={true} />
            <Image src={Subtract} className="hidden @md:hidden @lg:hidden @xl:block dark:hidden w-10 h-10" />
            <Image src={Subtract_Dark} className="hidden @md:hidden @lg:hidden @xl:dark:block w-10 h-10" />
          </div>
          <div className="flex gap-2">
            <PopupButton data={BANKER} handleChange={setBookerMarker} type={'bookmarker'} />
            <PopupButton data={BANKER_EXTENDS} handleChange={setBookMarkerExtend} />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default React.memo(HeaderFixture);
